/* eslint-disable no-console */
// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { changeUser } from "../redux/actions";
import FixedClock from "../lib/FixedClock";
import { POS_CALC_FREQ_SECS } from "../redux/settings";

/* Every second, update user.ideal_position in the store, based on room.video_position and room.video_position_timestamp */
// eslint-disable-next-line no-unused-vars
const VideoPositionCalculator = (props) => {

    const HEARTBEAT_INTERVAL_MSEC = 1000;

    useEffect(() => {
        heartbeat(); //do once immediately if we re-render because eg room position has changed
        const interval = setInterval(() => {
            heartbeat();
        }, HEARTBEAT_INTERVAL_MSEC);
        return () => clearInterval(interval);
    });

    /* Don't update more often than POS_CALC_FREQ_SECS to avoid a loop */
    const heartbeat = () => {
        const new_pos = calculateIdealPosition(props.is_playing, props.video_position, props.video_position_timestamp);

        if (Math.abs(new_pos - props.ideal_position) >  POS_CALC_FREQ_SECS) { 
            props.changeUser("ideal_position", new_pos);
        }
    };

    /* If we're playing, then assume 1s per s. If we're not playing, just return the position */
    const calculateIdealPosition = (is_playing, video_position, video_position_timestamp) => {

        /* If video position somehow got set to something weird like null or NaN, treat it as 0. Next time
        someone uses the controls, they'll write the correct one back. */
        video_position = video_position ? video_position : 0;
        video_position_timestamp = video_position_timestamp ? video_position_timestamp : 0;

        if (is_playing) {
            const secsSinceUpdate = (FixedClock.utc() - video_position_timestamp) / 1000;
            return (video_position + secsSinceUpdate);
        } else {
            return video_position;
        }
    };

    return null;

};




const mapStateToProps = state => ({ 
    is_playing: state.room.is_playing,
    video_position: state.room.video_position,
    video_position_timestamp: state.room.video_position_timestamp,
    ideal_position: state.user.ideal_position,
});
export default connect(mapStateToProps, { changeUser })(VideoPositionCalculator);